<template>
  <div class="main">
    <h2 class="title">登录入口</h2>
    <div class="content">
      <a href="http://www.naolamp.cn/m/sale/dls/login.html" target="_blank">代理商入口</a>
      <a href="http://autoled.com.cn/#/login" target="_blank">会员店入口</a>
      <a href="http://www.naolamp.cn/sale/home/preLogin" target="_blank">员工后台入口</a>
      <a href="http://old.naolamp.com/" target="_blank">旧官网入口</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'internal'
}
</script>

<style scoped>
  *{
    margin: 0;
    padding: 0;
    list-style: none;
  }
  html body{
    width: 100%;
    height: 100%;
  }
  .main{
    width: 80%;
    margin: 50px auto;
    padding: 20px;
    border-radius: 8px;
    background-color: #F2F6FC;
  }
  .title{
    text-align: center;
    height: 60px;
    line-height: 60px;
  }
  .content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .content a{
    width: 35%;
    height: 300px;
    line-height: 300px;
    text-decoration: none;
    text-align: center;
    border-radius: 10px;
    margin-top: 20px;
  }
  .content a:nth-child(odd){
    margin-right: 20px;
  }
  .content a:nth-child(event){
    margin-left: 20px;
  }
  .content a:nth-of-type(1){
    background-color: #67C23A;
  }
  .content a:nth-of-type(2){
    background-color: #E6A23C;
  }
  .content a:nth-of-type(3){
    background-color: #409EFF;
  }
  .content a:nth-of-type(4){
    background-color: #F56C6C;
  }
  a{
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/internal.vue